import { styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function AppTitle() {
    const { t } = useTranslation('navigation');

    return (
        <StyledText variant="h6">
            { t('title') }
        </StyledText>
    );
}

const StyledText = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
    fontSize: '1rem',
    margin: 0,

    [theme.breakpoints.between('sm', 'md')]: {
        display: 'none'
    }
}));
